class Auth {

  getCredentials(url, user) {
    // 10 second buffer
    let now = Date.now() + 10000;

    if (user && user.expiration > now) {
      if (url.match(/mc10cloud.com|localhost|127.0.0.1/) && url.indexOf("cdn.mc10cloud") === -1) {
        return Promise.resolve({
          id: user.user.id,
          token: user.accessToken
        });
      }
    }

    return Promise.resolve(null);
  }

}

module.exports = Auth;